import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SearchOffer } from 'modules/sapiSearch/slice';
import { getIsLockedDealExcludingGHA } from 'modules/search/selectors';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { EngineeredPrivateDealLogo } from '@daedalus/shared/src/privateDeal/EngineeredPrivateDealLogo';
import { ProviderLogo } from '@daedalus/shared/src/search/ProviderLogo';
import { ProviderName } from '@daedalus/shared/src/search/ProviderName';
type OfferLogoVariant = 'logo' | 'name' | 'iconAndName' | 'icon';
interface Props {
  offer: SearchOffer;
  variant?: OfferLogoVariant;
  height?: number;
  size?: 'sm' | 'md';
  providerCodeOverride?: string;
  isPrimaryOffer?: boolean;
  isSecondaryInlineOffer?: boolean; // Added as a part of 70766997-desktop-hotel-card-secondary-offers
  isSplitBooking?: boolean;
  isRequiredOneTimePasswordFlow?: boolean;
}

// Added as a part of 70766997-desktop-hotel-card-secondary-offers
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1kxh47d",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => EngineeredPrivateDealLogo;
const WrappedEngineeredPrivateDealLogo = /*#__PURE__*/styled(_exp())({
  name: "WrappedEngineeredPrivateDealLogo",
  class: "w1bavq5e",
  propsAsIs: true
});
export const OfferLogo: React.FC<Props> = ({
  offer,
  isPrimaryOffer = false,
  isSecondaryInlineOffer = false,
  variant = 'logo',
  size = 'md',
  providerCodeOverride,
  isSplitBooking = false,
  isRequiredOneTimePasswordFlow
}) => {
  const isLocked = useSelector(getIsLockedDealExcludingGHA(offer)) || isRequiredOneTimePasswordFlow;
  const {
    intermediaryProvider
  } = offer || {};
  if (isLocked && !providerCodeOverride && !isSplitBooking) return <div data-id="Logo">
        <WrappedEngineeredPrivateDealLogo className={cx(isPrimaryOffer && '__isPrimaryOffer')} />
      </div>;
  return <Wrapper data-id="Logo">
      <Flex.Row gap="s200">
        {(variant === 'logo' || variant === 'icon' || variant === 'iconAndName') && <ProviderLogo className={cx(isSecondaryInlineOffer && '__isSecondaryInlineOffer')} variant={variant === 'iconAndName' ? 'icon' : variant} providerCode={providerCodeOverride ? providerCodeOverride : intermediaryProvider} />}
        {(variant === 'name' || variant === 'iconAndName') && <ProviderName providerCode={providerCodeOverride ? providerCodeOverride : intermediaryProvider} size={size} />}
      </Flex.Row>
    </Wrapper>;
};

require("./OfferLogo.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./OfferLogo.tsx");